export default function HowDoIDetails() {
  return (
    <div>
      <div className="calhoun-street-bridge-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>How Do I?</h2>
        </div>
        {/*Start Main Content*/}
        <div className="content-fluid">
          {/*Start Center Container*/}
          <div className="mb-960-center-container mid-side-outlines">
            {/*Start Left Side Of Page*/}
            <div className="mb-960-col-50p">
              <h4>Police &amp; Public Safety</h4>

              {/* Accordion Start - Police How Do I */}
              <div className="container accordion-container">
                <div className="accordion" id="HowDoIAccordion">
                  {/* Item Start - Background Checks*/}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed  button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePolice06">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;Background Criminal History Checks</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePolice06" className="accordion-collapse collapse" data-bs-parent="#HowDoIAccordion">
                      <div className="accordion-body">
                        <div>
                          Please contact Pennsylvania State Police at{" "}
                          <a href="https://www.pa.gov/en/services/psp/request-a-criminal-history-background-check">
                            their website for background checks&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start - Car Seat Information */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed  button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePolice02">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;Car Seat Information</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePolice02" className="accordion-collapse collapse" data-bs-parent="#HowDoIAccordion">
                      <div className="accordion-body">
                        <div>
                          Please contact the Levittown-Fairless Hills Rescue Squad:
                          <br />
                          <a href="tel:215-547-2822" className="no-underline">
                            <i className="fa-solid fa-phone"></i>&nbsp;215-547-2822
                            <br />
                          </a>
                          <a href="http://www.lfhrs.com">
                            &nbsp;LFHRS Website&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start - Dispose of medications */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed  button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePolice04">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;Dispose of unused/expired medications</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePolice04" className="accordion-collapse collapse" data-bs-parent="#HowDoIAccordion">
                      <div className="accordion-body">
                        <div>
                          Solid ONLY drugs can be safely disposed at Morrisville Borough Hall (
                          <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8" className="no-underline">
                            <i className="fa-solid fa-location-pin"></i>&nbsp;35 Union Street Morrisville, PA 19067
                          </a>
                          ). <br />
                          We do not take sharps or anything in liquid form. Please dispose pills only, bottles should be discarded in the trash receptacle.
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish  */}
                  {/* Item Start - Fingerprints*/}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed  button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePolice05">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;Fingerprints (for Employment)</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePolice05" className="accordion-collapse collapse" data-bs-parent="#HowDoIAccordion">
                      <div className="accordion-body">
                        <div>
                          Please use{" "}
                          <a href="https://www.identogo.com">
                            www.identogo.com&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                          </a>{" "}
                          or visit them at 225 Lincoln Highway, Fairless Hills, PA 19030
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start - Gun Permits*/}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed  button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePolice07">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;Gun Permit / License To Carry Information</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePolice07" className="accordion-collapse collapse" data-bs-parent="#HowDoIAccordion">
                      <div className="accordion-body">
                        <div>
                          <a href="https://www.pa.gov/en/agencies/psp/programs/firearms/carrying-firearms-in-pennsylvania">
                            Click Here for PA Firearms website&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start - Obtain a Dog License */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed  button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePolice03">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;Obtain A Dog License</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePolice03" className="accordion-collapse collapse" data-bs-parent="#HowDoIAccordion">
                      <div className="accordion-body">
                        <div>
                          <a href="https://www.pa.gov/en/services/pda/apply-for-a-dog-license">
                            Click here to visit the registration site&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start - Obtain Police Reports*/}
                  <div className="stacked-accordion ">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed  button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePolice01">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;Obtain Police Reports</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePolice01" className="accordion-collapse collapse" data-bs-parent="#HowDoIAccordion">
                      <div className="accordion-body">
                        <div>
                          Reports can be picked up at the Police Department Monday through Friday 8am-4pm. Payment can be made by cash, check or money order only. Accident ($15.00). Incident Reports
                          ($20.00)
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}

                  {/* Item Start - Parking Notices */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed  button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePolice08">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;Payment of Parking Notices</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePolice08" className="accordion-collapse collapse" data-bs-parent="#HowDoIAccordion">
                      <div className="accordion-body">
                        <div>
                          Payments can be made at the Morrisville Borough Police Department during business hours: Monday - Friday 8am-4pm. Payments can be made by cash, check or money order only.
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start - Security Cameras*/}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed  button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePolice09">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;Security Camera Registration</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePolice09" className="accordion-collapse collapse" data-bs-parent="#HowDoIAccordion">
                      <div className="accordion-body">
                        <div>
                          Residents may register their cameras with the Morrisville Borough Police Department by sending their information (name, address, contact number) to:
                          <br />{" "}
                          <a href="m.williamson@morrisvillepolice.com">
                            <i className="fa-solid fa-envelope"></i>&nbsp;m.williamson@morrisvillepolice.com
                          </a>
                          <br />
                          This information is helpful in assisting the Morrisville Borough Police in various public safety and investigations.
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start - Vehicle Release Forms */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed  button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePolice10">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;Vehicle Release Forms</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePolice10" className="accordion-collapse collapse" data-bs-parent="#HowDoIAccordion">
                      <div className="accordion-body">
                        <div>
                          Vehicle Release Forms Can be picked up at the Morrisville Borough Police Department during business hours: Monday through Friday 8am-4pm. Payment can be made by cash, check
                          or money order only. ($20.00)
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Police How Do I */}
            </div>
            <div className="mb-960-col-50p">
              <h4>Government</h4>

              {/* Accordion Start - Government How Do I */}
              <div className="container accordion-container">
                <div className="accordion" id="GovernmentAccordion">
                  {/* Item Start - Apply To Board Or Commission*/}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed  button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseGovernment01">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;Apply To Join A Board or Commission</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseGovernment01" className="accordion-collapse collapse" data-bs-parent="#GovernmentAccordion">
                      <div className="accordion-body">
                        <div>
                          Please send letters of interest to:<br/> <a href="mailto:office@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;office@morrisvilleboro.org
                  </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  
                  
                </div>
              </div>
              {/* Accordion Finish - Government How Do I */}
            </div>
          </div>
        </div>

        <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
      </div>
    </div>
  );
}

   